export const GET_QUOTA_TYPES = 'GET_QUOTA_TYPES'
